import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-cta bg-wood" data-id="element-118" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-119" data-mp="icgf1beeat1f">
        <p className="font-display text-xs font-bold uppercase tracking-widest text-cta" data-id="element-120" data-mp="meac79pdtewu">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-121" data-mp="rbtr8btwlvpu">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-cta bg-white text-charcoal" data-id="element-122" data-mp="2t7mbij5439dp">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-123" data-mp="12n8lntatlwlo">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-124" data-mp="xv8na5aefbr7" />
          </a>
          <div className="p-3" data-id="element-125" data-mp="oxonl0s6pnip">
            <p className="font-display text-sm font-black uppercase leading-tight text-wood" data-id="element-126" data-mp="ouaktrflzcaq">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-anton text-2xl uppercase tracking-wide" data-id="element-127" data-mp="1gn1kkbwi3j4q">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-xs text-charcoal/80 sm:text-sm" data-id="element-128" data-mp="1ck4u5z0pyiq8">
              🎁 Bonos valorados en{' '}
              <span className="font-semibold text-red-600 line-through" data-id="element-129" data-mp="17mbqpdqsw2tn">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-red-600 px-2.5 py-0.5 font-display text-xs font-black uppercase tracking-wide text-white" data-id="element-130" data-mp="3sd3tpqxfzcyk">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-display text-5xl font-extrabold leading-none tracking-tight text-wood sm:text-6xl" data-id="element-131" data-mp="2ng7y36bfcd8">
              <span className="text-3xl italic text-charcoal sm:text-4xl" data-id="element-132" data-mp="3ku2yru0pirmt">
                Hoy:
              </span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-medium text-charcoal/80" data-id="element-133" data-mp="3owr7m1pf7yjs">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-134" data-mp="3fv9ums7b8czb">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-medium text-charcoal/80" data-id="element-135" data-mp="364ez0x86c117">
              <span className="flex items-center gap-1" data-id="element-136" data-mp="2s5oz79tyzn95">
                <ZapIcon size={12} className="text-wood" data-id="element-137" data-mp="2x3qtkqwuj8zx" />
                Acceso Inmediato
              </span>
              <span className="text-charcoal/40" data-id="element-138" data-mp="2dhoxhclx8adr">•</span>
              <span className="flex items-center gap-1" data-id="element-139" data-mp="2di73h0ydy2yv">
                <ShieldCheckIcon size={12} className="text-wood" data-id="element-140" data-mp="28jnfkv08eh3v" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}